import React from "react";
import { Group, Grid, Stack, Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { calculateTotalDuration } from "../../utils/timeUtils";

function StaffServiceDetails({ employee, service, staffService }) {
  const canPerform = staffService !== undefined;

  return (
    <Stack position="apart" py="xs">
      <Group>
        {canPerform ? (
          <IconCheck size={16} color="green" />
        ) : (
          <IconX size={16} color="red" />
        )}
        <Text size="sm">
          {employee.first_name} {employee.last_name} - {employee.title}
        </Text>
      </Group>
      {canPerform && (
        <Grid align="center" pl="xl">
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={500} size="sm">
                Duration
              </Text>
              <Text
                size="sm"
                c={
                  calculateTotalDuration(staffService) ===
                  calculateTotalDuration(service)
                    ? "dimmed"
                    : "inherit"
                }
              >
                {calculateTotalDuration(staffService) ===
                calculateTotalDuration(service)
                  ? "Same as default"
                  : `${calculateTotalDuration(staffService)} minutes`}
              </Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={500} size="sm">
                Price
              </Text>
              <Text
                size="sm"
                c={
                  staffService.price === service.default_price &&
                  staffService.is_variable_price ===
                    service.default_is_variable_price
                    ? "dimmed"
                    : "inherit"
                }
              >
                {staffService.price === service.default_price &&
                staffService.is_variable_price ===
                  service.default_is_variable_price
                  ? "Same as default"
                  : staffService.is_variable_price
                    ? `$${staffService.price} and up`
                    : `$${staffService.price}`}
              </Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={500} size="sm">
                Self-Service
              </Text>
              <Text
                size="sm"
                c={
                  staffService.is_self_servicable ===
                  service.default_is_self_servicable
                    ? "dimmed"
                    : "inherit"
                }
              >
                {staffService.is_self_servicable ===
                service.default_is_self_servicable
                  ? "Same as default"
                  : staffService.is_self_servicable
                    ? "Yes"
                    : "No"}
              </Text>
            </Stack>
          </Grid.Col>
        </Grid>
      )}
    </Stack>
  );
}

export default StaffServiceDetails;
